import React, { Children, Suspense } from 'react';

import Loader from 'components/navigation/Loader';
import { useTranslation } from 'react-i18next';

import { Container, Paper, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import DocsLinks from './DocsLinks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 5fr',
      gridGap: theme.spacing(2),
      padding: theme.spacing(2),
      margin: theme.spacing(2),
    },
    main: {
      textAlign: 'left',
    },
  }),
);

const DocsView = ({ children }: any) => {
  const classes = useStyles();
  const { t } = useTranslation(['docs']);

  const loader = <Loader open={true} reason={t('docs:docs_loading')} />;

  return (
    <Container>
      <Paper className={classes.container}>
        <aside>
          <Typography align="left" variant="h4">
            Docs
          </Typography>
          <DocsLinks />
        </aside>
        <main className={classes.main}>
          <Suspense fallback={loader}>{Children.only(children)}</Suspense>
        </main>
      </Paper>
    </Container>
  );
};

export default DocsView;
